import type { CommentThread } from '@/shared/types/comment';
import type { User } from '@/shared/types/user';

export function addThreadParticipant(
  selectedIds: string[],
  userId: string,
): string[] {
  return selectedIds.includes(userId) ? selectedIds : [...selectedIds, userId];
}

export function removeThreadParticipant(
  selectedIds: string[],
  userId: string,
): string[] {
  return selectedIds.filter((id) => id !== userId);
}

export function threadDisplayTitle(
  thread: CommentThread,
  usersById: Map<string, User>,
  currentUserId?: string,
): string {
  const topic = thread.data.title.trim();
  if (topic || thread.data.kind === 'default') {
    return topic || 'Profile comments';
  }

  const participantNames = thread.data.member_ids
    .filter((memberId) => memberId !== currentUserId)
    .map((memberId) => usersById.get(memberId)?.data.displayName)
    .filter((name): name is string => Boolean(name));
  if (participantNames.length > 2) {
    return `${participantNames.slice(0, 2).join(', ')} +${participantNames.length - 2}`;
  }
  if (participantNames.length) {
    return participantNames.join(', ');
  }

  return thread.data.member_ids.includes(currentUserId || '')
    ? 'Just you'
    : 'Private thread';
}
